/**
 * External Dependencies
 */
import 'jquery';
import { tns } from 'tiny-slider/src/tiny-slider';
import 'alpinejs';
import simpleParallax from 'simple-parallax-js';
import "@fancyapps/ui";

$(document).ready(() => {
  // console.log('Hello world');

  var images = document.querySelectorAll('.parallax');
	new simpleParallax(images, {
    delay: .6,
    transition: 'cubic-bezier(0,0,0,1)'
  });
  
  const initSpacesSlider = () => {

    var heroEl = '.spaces-hero-slider';

    if($(heroEl).length > 0) {
      var slider = tns({
        container: heroEl,
        items: 1,
        // lazyload: true,
        controls: false,
        loop: false,
        navContainer: '.pagination',
        navAsThumbnails: true,
        slideBy: 'page',
        autoplay: false,
      }); 
    }

    var singleSpaceSliders = document.querySelectorAll('.single-space');
    
    singleSpaceSliders.forEach(function (space) {
      var slider = space.querySelector('.spaces-slider');
      var pagination = space.querySelector('.pagination');
      tns({
        container: slider,
        items: 1,
        // lazyload: true,
        loop: false,
        controls: false,
        navContainer: pagination,
        navAsThumbnails: true,
        slideBy: 'page',
        autoplay: false,
      });
    });

  }

  const tabNavClick = () => {
    $(document).on('click', '.tab-nav a', function(e) {
      e.preventDefault();
      var currentIndex = $('.tab-active').data('index');
      var index = $(this).data('index');

      $('a[data-index="'+currentIndex+'"]').removeClass('tab-active');
      $('a[data-index="'+index+'"]').addClass('tab-active');
      
      $('div#tab'+currentIndex).addClass('hidden');
      $('div#tab'+index).removeClass('hidden');
    });
  }

  const menuSwap = (currentPos) => {
    var banner = $('.banner');
    var bannerHeight = $(banner).outerHeight(true);

    if(currentPos > bannerHeight) {
      $('.hamburger').addClass('is-hidden');

      if($('.nav-wrapper button').hasClass('is-active')) {
        //
      } else {
        $('.extra-menu').addClass('is-hidden');
      }

      $('.hamburger-swap').removeClass('is-hidden');
    } else {
      $('.hamburger').removeClass('is-hidden');

      if($('.nav-wrapper button').hasClass('is-active')) {
        //
      } else {
        $('.extra-menu').removeClass('is-hidden');
      }

      $('.hamburger-swap').addClass('is-hidden');
    }
  }

  const menuToggle = () => {
    $('.nav-wrapper button').on('click touch tap', function() {
      if($(this).hasClass('is-active') && $(this).hasClass('hamburger-swap')) {

        if($(window).scrollTop() > $('.banner').outerHeight(true)) {
          $('.extra-menu').addClass('is-hidden');
        }
      } else {
        $('.extra-menu').removeClass('is-hidden');
      }

      $('.nav-wrapper button').toggleClass('is-active');
      $('.side-menu').toggleClass('menu-active');
    });
  }

  $(window).on('scroll', function(e) {

    if($(window).width() > 1024) {
      var currentPos = $(window).scrollTop();
      menuSwap(currentPos);
  
      e.stopImmediatePropagation();
    }
  });

  const onInputFocus = () => {
    $(document).on('focus', '.ginput_container > *', function() {
      var label = $(this).parent().parent().find('label');
      $(label).css("transform", "translateY(0)");
    });

    $(document).on('focusout', '.ginput_container > *', function() {

      var label = $(this).parent().parent().find('label');

      if($(this).val() !== '') {
        //
      } else {
        $(label).css("transform", "translateY(30px)");
      }

    });
  }

  menuToggle();
  initSpacesSlider();

  $(window).load(function() {
    // Run function after window has loaded
    onInputFocus();
    tabNavClick();
  });

});
